module.exports = __webpack_public_path__ + "img/folder_managed_hover.061618cb.svg";